import React from 'react';

import { Checkbox } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

const LegalCheckbox: React.FC<{
  className?: string;
  checkedTerms: boolean;
  setCheckedTerms?: (value: boolean) => void;
  isMembership?: boolean;
  onCustomChange?: (value: { complete: boolean; value: boolean }) => void;
  darkMode?: boolean;
}> = ({
  className,
  checkedTerms,
  setCheckedTerms,
  isMembership,
  onCustomChange,
  darkMode,
}) => {
  const { t } = useTranslation();
  const onChange = () => {
    if (onCustomChange) {
      onCustomChange({
        complete: !checkedTerms,
        value: !checkedTerms,
      });
    } else if (setCheckedTerms) {
      setCheckedTerms(!checkedTerms);
    }
  };

  return (
    <div className={className} data-testid="legal">
      <div className="flex items-start">
        <Checkbox
          checked={checkedTerms}
          data-testid="checkbox-legal"
          small
          onChange={onChange}
          darkMode={darkMode}
        />
        {isMembership ? (
          <a
            href="/legal/politicas-de-membresias/"
            target="_blank"
            className={`ml-8 font-legals tw-font-semibold cursor-pointer sm:text-left ${
              darkMode ? 'text-white' : 'text-gray-dark'
            }`}
            data-testid="terms-conditions"
          >
            {t('CHECKBOX_LABEL')}
            {t('CHECKBOX_LEGAL_FULL')}
          </a>
        ) : (
          <a
            href="/legal/terminos-y-condiciones/"
            target="_blank"
            className={`ml-8 font-legals tw-font-semibold cursor-pointer sm:text-left ${
              darkMode ? 'text-white' : 'text-gray-dark'
            }`}
            data-testid="terms-conditions"
          >
            {t('CHECKBOX_LABEL')}
            {t('CHECKBOX_LEGAL')} {t('LEGAL_LINK_TEXT')}
          </a>
        )}
      </div>
      {!checkedTerms && (
        <p className="mt-12 font-legals text-red-main" role="alert">
          {t('LEGAL_ERROR_TEXT')}
        </p>
      )}
    </div>
  );
};

export default LegalCheckbox;
